import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const ViewProduct: React.FC = () => {
  const [valueTabs, setValueTabs] = useState<number>(0);
  const [isAdminReplyOpen, setIsAdminReplyOpen] = useState<boolean>(false);
  const [adminReplyText, setAdminReplyText] = useState<string>("");
  const navigate = useNavigate();

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const CustomTabPanel: React.FC<TabPanelProps> = ({
    children,
    value,
    index,
    ...other
  }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );

  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  // Dummy reviews data (replace with API data if needed)
  const reviews = [
    {
      id: 1,
      userName: "Alice Johnson",
      email: "alice.johnson@example.com",
      orderId: "#Order_0001",
      rating: 5,
      review:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
      date: "25 July 2025",
      userImage: "assets/images/profile.png",
    },
    {
      id: 2,
      userName: "Alice Johnson",
      email: "alice.johnson@example.com",
      orderId: "#Order_0002",
      rating: 5,
      review:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
      date: "25 July 2025",
      userImage: "assets/images/profile.png",
    },
    {
      id: 3,
      userName: "Alice Johnson",
      email: "alice.johnson@example.com",
      orderId: "#Order_0003",
      rating: 5,
      review:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
      date: "25 July 2025",
      userImage: "assets/images/profile.png",
    },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  // Admin Actions State
  const actionButtonRef = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [hideReview, setHideReview] = useState(false);
  const [hideVendorReply, setHideVendorReply] = useState(false);
  const [hideThread, setHideThread] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<"advice" | "note" | null>(null);
  const [dialogText, setDialogText] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleMenuClick = () => {
    setIsMenuOpen(true);
  };
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleAction = (action: string) => {
    handleMenuClose();
    switch (action) {
      case "hide_review":
        setHideReview(!hideReview);
        setSnackbarMessage(hideReview ? "Review Unhidden" : "Review Hidden");
        setSnackbarOpen(true);
        break;
      case "hide_vendor_reply":
        setHideVendorReply(!hideVendorReply);
        setSnackbarMessage(
          hideVendorReply ? "Vendor Reply Unhidden" : "Vendor Reply Hidden",
        );
        setSnackbarOpen(true);
        break;
      case "hide_thread":
        setHideThread(!hideThread);
        setSnackbarMessage(hideThread ? "Thread Unhidden" : "Thread Hidden");
        setSnackbarOpen(true);
        break;
      case "send_advice":
        setDialogType("advice");
        setDialogText("");
        setDialogOpen(true);
        break;
      case "add_note":
        setDialogType("note");
        setDialogText("");
        setDialogOpen(true);
        break;
      case "public_reply":
        setIsAdminReplyOpen(true);
        break;
      default:
        break;
    }
  };

  const handleDialogSubmit = () => {
    // API call logic would go here
    console.log(`Submitted ${dialogType}:`, dialogText);
    setDialogOpen(false);
    setDialogText("");
    setSnackbarMessage(
      dialogType === "advice"
        ? "Private Advice Sent to Vendor"
        : "Internal Note Added",
    );
    setSnackbarOpen(true);
  };

  return (
    <>
      <div className="main_title">
        <h1>View Product</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>
            Manage Products
          </button>
          - View Product
        </p>
      </div>

      <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="view product tabs"
          className="custom_tabs_links"
        >
          <Tab label="General Details" {...a11yProps(0)} />
          <Tab label="Reviews" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <div className="cards">
        {/* ---------------------- TAB 1: General Details ---------------------- */}
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="view_page variants">
            <div className="gap_p">
              <div className="w_33">
                <h6>Product ID</h6>
                <p>
                  <strong className="c_black">#PROD-001</strong>
                </p>
              </div>
              <div className="w_33">
                <h6>Product Name</h6>
                <p>Men Sports Shoes</p>
              </div>
              <div className="w_33">
                <h6>Product Category</h6>
                <p>Footwear</p>
              </div>
              <div className="w_33">
                <h6>Product Sub-Category</h6>
                <p>Shoes</p>
              </div>
              <div className="w_33">
                <h6>Brand</h6>
                <p>Nike</p>
              </div>
              <div className="w_33">
                <h6>Created Date</h6>
                <p>30 July 2025</p>
              </div>
              <div className="w_33">
                <h6>Status</h6>
                <p>
                  <SwitchToggle />
                </p>
              </div>

              <div className="w_33">
                <h6>Product Details</h6>
                <ul className="feature_lst">
                  <li>
                    <strong>Sizing:</strong> Lorem
                  </li>
                  <li>
                    <strong>Material:</strong> 42% Cotton
                  </li>
                  <li>
                    <strong>Fit:</strong> Casual Fit
                  </li>
                  <li>
                    <strong>Fabric Name:</strong> Knit
                  </li>
                </ul>
              </div>
              <div className="w_33">
                <h6>Delivery & Returns </h6>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Dolorem, id.
                </p>
              </div>
              <div className="w_33">
                <h6>Product Description</h6>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Dignissimos cum odio, sequi, possimus quibusdam voluptatum
                  adipisci cupiditate et, iure iste aliquam! Dolore, magnam
                  delectus. Temporibus distinctio id adipisci obcaecati quaerat!
                </p>
              </div>
              <div className="w_100">
                <h6>Warranty</h6>
                <p>
                  <strong>Shipping details</strong>
                  <br />
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Blanditiis ipsam alias aliquam ad earum labore quam at
                  quaerat, quo et!
                </p>
                <p>
                  <strong>Return details</strong>
                  <br />
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Blanditiis ipsam alias aliquam ad earum labore quam at
                  quaerat, quo et!
                </p>
              </div>
            </div>

            <div className="create_variant mt_20">
              <ul>
                <li>
                  <strong>Colour</strong> Black
                </li>
                <li>
                  <strong>Size</strong> L
                </li>
              </ul>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Variant Name</h6>
                  <p>Variant 1</p>
                </div>

                <div className="w_33">
                  <h6>Price</h6>
                  <p>$140</p>
                </div>
                <div className="w_33">
                  <h6>Discounted Price</h6>
                  <p>$120</p>
                </div>
                <div className="w_33">
                  <h6>Comission</h6>
                  <p>GST (5%)</p>
                </div>
                <div className="w_33">
                  <h6>Quantity for inventory</h6>
                  <p>100</p>
                </div>
                <div className="w_33">
                  <h6>Maximum Purchase Limit</h6>
                  <p>10</p>
                </div>

                <div className="w_100">
                  <h6>Product Images</h6>
                  <div className="gap_p form">
                    {[1, 2, 3, 4, 5].map((img) => (
                      <div key={img} className="vew_img no_radius w_33">
                        <figure>
                          <img
                            alt="Product"
                            src="/static/images/placeholder.png"
                          />
                        </figure>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="product_reviews mt_20">
              <h4>Customer Rating</h4>

              {/* Single Review */}
              <div className="review_card">
                {hideThread ? (
                  <div
                    className="thread_hidden_placeholder"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#888",
                      fontStyle: "italic",
                    }}
                  >
                    <p>This thread has been hidden by an admin.</p>
                    <Button
                      onClick={() => setHideThread(false)}
                      size="small"
                      variant="outlined"
                    >
                      Unhide Thread
                    </Button>
                  </div>
                ) : (
                  <>
                    <div className="review_header">
                      <div className="user_info">
                        <strong>Ahmed Khan</strong>
                        <span className="review_date">12 Jan 2026</span>
                      </div>

                      <div className="rating">
                        ⭐⭐⭐⭐☆ <span className="rating_value">4.0</span>
                      </div>
                    </div>

                    <p
                      className={`review_text`}
                      style={
                        hideReview ? { filter: "blur(4px)", opacity: 0.5 } : {}
                      }
                    >
                      The quality of the product is really good and matches the
                      description. Delivery was on time. Slightly expensive but
                      worth it.
                    </p>
                    {hideReview && (
                      <small
                        style={{
                          color: "red",
                          display: "block",
                          marginBottom: 10,
                        }}
                      >
                        Review Hidden by Admin
                      </small>
                    )}

                    {/* Vendor Reply */}
                    <div
                      className="vendor_reply"
                      style={
                        hideVendorReply
                          ? { filter: "blur(4px)", opacity: 0.5 }
                          : {}
                      }
                    >
                      <div className="reply_header">
                        <strong>Vendor Reply</strong>
                        <span className="reply_tag">Official Response</span>
                      </div>
                      <p>
                        Thank you for your valuable feedback, Ahmed! We’re glad
                        you liked the product. We’ll definitely work on pricing
                        and bring more offers soon.
                      </p>
                    </div>
                    {hideVendorReply && (
                      <small
                        style={{
                          color: "red",
                          display: "block",
                          marginBottom: 10,
                        }}
                      >
                        Vendor Reply Hidden by Admin
                      </small>
                    )}

                    {/* Take Action Button & Admin Reply Field */}
                    <div className="admin_action_area">
                      <Button
                        ref={actionButtonRef}
                        className="btn btn_primary sm"
                        onClick={handleMenuClick}
                      >
                        Admin Actions ▾
                      </Button>
                      <Menu
                        anchorEl={actionButtonRef.current}
                        open={isMenuOpen}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <MenuItem onClick={() => handleAction("hide_review")}>
                          {hideReview
                            ? "Unhide Customer Review"
                            : "Hide Customer Review"}
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleAction("hide_vendor_reply")}
                        >
                          {hideVendorReply
                            ? "Unhide Vendor Reply"
                            : "Hide Vendor Reply"}
                        </MenuItem>
                        <MenuItem onClick={() => handleAction("hide_thread")}>
                          {hideThread
                            ? "Unhide Entire Thread"
                            : "Hide Entire Thread"}
                        </MenuItem>
                        <MenuItem onClick={() => handleAction("send_advice")}>
                          Send Private Advice to Vendor (AI Assist)
                        </MenuItem>
                        <MenuItem onClick={() => handleAction("public_reply")}>
                          Post Public Reply
                        </MenuItem>
                        <MenuItem onClick={() => handleAction("add_note")}>
                          Add Internal Note
                        </MenuItem>
                      </Menu>

                      {isAdminReplyOpen && (
                        <div className="admin_reply_field form">
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            placeholder="Type your reply to the customer..."
                            value={adminReplyText}
                            onChange={(e) => setAdminReplyText(e.target.value)}
                          />
                          <div className="reply_actions">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                console.log(
                                  "Admin Reply Submitted:",
                                  adminReplyText,
                                );
                                setIsAdminReplyOpen(false);
                                setAdminReplyText("");
                              }}
                            >
                              Post Reply
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </CustomTabPanel>

        {/* ---------------------- TAB 2: Reviews ---------------------- */}
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_flex">
            <div className="lt">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search..."
                    />
                  </Box>
                </div>
                <div className="right_s"></div>
              </div>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No</TableCell>
                      <TableCell>User Details</TableCell>
                      <TableCell>Order ID</TableCell>
                      <TableCell>Rating</TableCell>
                      <TableCell>Review</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Hide Review</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {reviews.map((item, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{item.id}</TableCell>
                        <TableCell>
                          <div className="user_block click_action">
                            <figure>
                              <img
                                src="/static/images/user_placeholder.png"
                                alt="User"
                              />
                            </figure>
                            <p>
                              <b>{item.userName}</b>
                              {item.email}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <strong>{item.orderId}</strong>
                        </TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <Typography>{item.rating}</Typography>
                            <StarIcon sx={{ color: "#fbc02d", fontSize: 18 }} />
                          </Box>
                        </TableCell>
                        <TableCell className="max_c2">
                          <p>{item.review}</p>
                        </TableCell>
                        <TableCell>{item.date}</TableCell>
                        <TableCell>
                          <Button className="btn btn_primary sm">Hide</Button>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="error"
                            onClick={() =>
                              console.log("Delete review", item.id)
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="rt">
              <div className="ai_panel">
                <h4>AI Insights</h4>

                <div className="ai_alert warning">
                  <span className="icon">⚠️</span>
                  <p>
                    <b>7 SKUs</b> need immediate attention
                  </p>
                </div>

                <div className="ai_alert danger">
                  <span className="icon">⛔</span>
                  <p>
                    <b>3 SKUs</b> have zero sales in 30 days
                  </p>
                </div>

                <small className="ai_update">
                  Next updated ETA: <b>May 5, 2024</b>
                </small>

                <div className="ai_sku_list">
                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_002</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_010</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>
                </div>

                {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
              </div>
            </div>
          </div>
        </CustomTabPanel>
      </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>
          {dialogType === "advice"
            ? "Send Private Advice to Vendor"
            : "Add Internal Note"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={
              dialogType === "advice"
                ? "Advice Message (Not visible to customer)"
                : "Note (Visible only to admins)"
            }
            type="text"
            fullWidth
            multiline
            rows={4}
            value={dialogText}
            onChange={(e) => setDialogText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDialogSubmit} variant="contained">
            {dialogType === "advice" ? "Send Advice" : "Save Note"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ViewProduct;
